import {ThemeIconKey} from 'platform/foundation';

export type LightboxAction = {
  id: string;
  icon: ThemeIconKey;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick: (imageId: number | string) => void;
};
